import { DataDRequest } from "../../../data/DRequest";
import { Entidad } from "../../../data/Entidad";
import { UIUtilLang } from "../../util/Language";
import { NotificacionV2 } from "../NotificacionV2";
import { _ModalThingsBase } from "./ModalThingsBase";
import { ModalThingsUtil as util } from "./Utils";

import CAccionPermiso = Entidad.CAccionPermiso;

type IModalThings<Extras> = util.IModalThings<Extras>;
type IModalThingsBase1 = util.IModalThingsBase1


export interface IModalToAProccessConfig<TExtras> extends Pick<IModalThingsBase1, "Title" | "Modulo" | "Action" | "IdsEscuelas" | "LangModuleKeyInContext"> {
    /** Si se define "Action", por default toma la cadena del key del enum, a menos que se defina */
    AccionToHttpMessage?: string;
    /** Personaliza contenido extra despues del mensaje de confirmación */
    DrawContent?: (content: TSelectionHTML<"div">, modalThings: IModalThings<TExtras>) => void;
    /** @default 500 px */
    Width?: number;
    Height?: string;
    OnClose?: () => void;
    OnAccept?: (modalThings: IModalThings<TExtras>) => Promise<DataDRequest.IResultadoPeticion<any>>;
}

/** Modal especial para un proceso X */
export function _ModalToAProccess<TExtras = any>(config: IModalToAProccessConfig<TExtras>) {
    const finalConfig: IModalToAProccessConfig<TExtras> = {
        ... <IModalToAProccessConfig<TExtras>>{
            Width: 500,
            AccionToHttpMessage: CAccionPermiso[config.Action]
        },
        ...config
    }

    // >> Langcontext fix
    const langContextTitle = util.GetLangContext(finalConfig.LangModuleKeyInContext, finalConfig.Title, finalConfig.Modulo, finalConfig.Action);

    // Create ModalThings
    let modalT = _ModalThingsBase<TExtras>(langContextTitle.StringTag, finalConfig.Width, "body_temp", undefined, config.Height);

    // Draw content
    if (finalConfig.DrawContent) {
        finalConfig.DrawContent(modalT.CurrentBody, modalT);
    }

    // Verificacion de permisos
    let hasPermission = util.ActionPermission(config.Action, config.Modulo, config.IdsEscuelas);

    modalT.Modal._OnClose(finalConfig.OnClose);

    if (!finalConfig.OnAccept || !hasPermission) {
        modalT.Modal._FooterSelection
            .remove();
    } else {
        modalT.BtnLeft.classed("hide_transparent", false);
        //     modalT.BtnLeft.remove();
        // }
        modalT.Modal._FooterSelection
            .style("justify-content", null);

        modalT.BtnLeft
            .style("margin-right", "0px")
            .on("click", () => {
                modalT.Modal._Ocultar();
            })

        modalT.BtnRight
            .on("click", async () => {
                if (modalT.BtnRight.classed("btn_disable")) return;
                modalT.Modal._DeshabilitarBtns();
                modalT.Progress.attr("oculto", false);
                // if (finalConf.OnAccept instanceof Promise) {
                let res = await finalConfig.OnAccept(modalT);

                if (res) {
                    let mess = UIUtilLang._GetHTTPMessage(res, finalConfig.AccionToHttpMessage);
                    if (res.Resultado > 0) {
                        modalT.Modal._Ocultar();
                    } else {
                        modalT.Modal._HabilitarBtns();
                        modalT.Progress.attr("oculto", true);
                    }
                    NotificacionV2._Mostrar(mess, res.Resultado > 0 ? "INFO" : "ADVERTENCIA");
                } else {
                    modalT.Modal._HabilitarBtns();
                    modalT.Progress.attr("oculto", true);
                }
            });
    }
    return modalT;
}